import React from "react";
import GroupDownloadCollapsePanel from "@/components/Joyspace/components/GroupDownloadPanel";
import GroupJoySpaceUploadBox from "@/components/Joyspace/components/GroupUploadPanel";
import "./index.less";

const GroupCollapsePanel = (props: any) => {
  const { gid } = props;
  return (
    <div className="joyspace-group-collapse">
      <GroupJoySpaceUploadBox gid={gid} />
      <GroupDownloadCollapsePanel gid={gid} className="joyspace-download" />
    </div>
  );
};

export default GroupCollapsePanel;
